<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <div class="containerHeader" style="margin: 0px 20px">
            <h1 class="titleModal blue">Importer en comptabilitée</h1>
            <i @click="close" class="fa-solid fa-xmark fa-xl closeButton"></i>
          </div>
        </header>

        <div class="containerBody"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal_BankInfo",
  props: [],
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style></style>
